import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import SingleFieldManager from "@com/SingleFieldManager.vue";
export default {
  __name: 'RoomFacilitieManager',

  setup(__props) {
    const config = {
      name: '房间设施',
      type: 'roomFacilitie',
      route: 'roomfacilitiemanager'
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(SingleFieldManager, {
        config: config
      });
    };
  }

};